import {
  Component,
  ElementRef,
  ViewChild,
  ViewChildren, // Toevoegen
  QueryList, // Toevoegen
  AfterViewInit,
  HostListener,
} from "@angular/core";

@Component({
  selector: "app-horizontal-scroll-home",
  templateUrl: "./horizontal-scroll-home.component.html",
  styleUrls: ["./horizontal-scroll-home.component.scss"],
})
export class HorizontalScrollHomeComponent implements AfterViewInit {
  @ViewChildren("videoPlayer") videoPlayers!: QueryList<
    ElementRef<HTMLVideoElement>
  >;
  @ViewChild("section", { static: false })
  section!: ElementRef<HTMLElement>;

  @ViewChild("scrollWrapper", { static: false })
  scrollWrapper!: ElementRef<HTMLElement>;

  translateX = 0;
  maxTranslateX = 0;

  items = [
    {
      title: "Danvi Coffee Roasters",
      text: "Coffee with good taste.",
      image: "/assets/img/danvi/danvi-main-home.jpg",
      logo: "/assets/img/logo-home-danvi.svg",
      button: "Bekijk",
      link: "/danvi2",
      component: "DanviComponent2",
    },

    {
      title: "Vittaa App",
      text: "Designing an online meet up platform for people who want to run, bike or hike together.",
      image: "/assets/img/vittaa/vittaa-main-bg.webp",
      logo: "/assets/img/logo-home-vittaa.svg",
      button: "Bekijk",
      link: "/vittaa-app",
      component: "VittaaComponent",
    },
    {
      title: "Ondergrondsverbond",
      text: "Beschrijving nummer vier.",
      image: "/assets/img/ov/ov-main-bg.webp",
      logo: "/assets/img/logo-home-hetzwolsverbond.svg",
      button: "Bekijk",
      link: "/ondergrondsverbond",
      component: "OndergrondsverbondComponent",
    },
    {
      title: "Aurea Interieur",
      text: "Korte beschrijving van dit project.",
      image: "/assets/img/aurea/aurea-main-bg.webp",
      logo: "/assets/img/logo-home-aurea.svg",
      button: "Bekijk",
      link: "/aurea",
      component: "AureaComponent",
    },
    {
      title: "Random Stuff",
      text: "Korte beschrijving van dit project.",
      image: "/assets/img/random/random_stuff.mp4",
      logo: "/assets/img/logo-home-random.svg",
      button: "Bekijk",
      link: "/work",
      component: "WorkComponent",
    },
    /* --
    {
      title: "Knivesandtools",
      text: "Visual design for a web shop offering a wide range of kitchen and outdoor tools.",
      image: "/assets/img/kat/kat-main-bg.webp",
      logo: "/assets/img/logo-home-kat.svg",
      button: "Bekijk",
      link: "/kat",
      component: "KatComponent",
    },
    --*/
  ];

  ngAfterViewInit() {
    this.calculateHeights();
    this.playVideos();
  }
  private playVideos() {
    setTimeout(() => {
      this.videoPlayers.forEach((video) => {
        const player = video.nativeElement;

        player.muted = true;
        player.setAttribute("muted", "");

        player.play().catch((err) => {
          console.warn("Video kon niet automatisch starten:", err);
        });
      });
    }, 100);
  }

  @HostListener("window:resize")
  onResize() {
    this.calculateHeights();
  }

  @HostListener("window:scroll")
  onScroll() {
    const sectionTop = this.section.nativeElement.offsetTop;
    const scrollTop = window.pageYOffset - sectionTop;

    this.translateX = Math.max(0, Math.min(scrollTop, this.maxTranslateX));
  }

  private calculateHeights() {
    const wrapper = this.scrollWrapper.nativeElement;
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Voeg een kleine extra buffer toe (bijv. 100px) of zorg dat de
    // padding-right van de CSS wordt meegeteld.
    this.maxTranslateX = wrapper.scrollWidth - viewportWidth;

    // BELANGRIJK: Als je merkt dat hij nog steeds stopt,
    // kun je hier handmatig 24px of 32px (je margin/gap) bij optellen.
    // this.maxTranslateX += 32;

    const totalHeight = this.maxTranslateX + viewportHeight;
    this.section.nativeElement.style.height = `${totalHeight}px`;
  }
}
